import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from "./api/index";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.css'
import '@/lib/style/index.css'
import './permission'

Vue.prototype.$api = api
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

